import React from 'react'
import WorkshopList from '../../Components/AdminComponents/WorkshopList/WorkshopList';
import AdminDash from '../../Components/AdminComponents/AdminDash/AdminDash';

function WorkshopListPage() {
  return (
    <AdminDash>
        <WorkshopList/>
    </AdminDash>
  )
}

export default WorkshopListPage